import styled from 'styled-components'

export const MainContainer = styled.div`
  background-color: #eef4f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
`

export const Heading = styled.h1`
  color: #334155;
  font-family: 'Roboto';
  font-size: 32px;
  font-weight: 600;
  text-decoration: underline #52bbf0;
  text-underline-offset: 20%;
  margin: 10px;
  align-self: center;
`
export const TravelCardContainer = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
`
